import { render, staticRenderFns } from "./matomo-traefik.vue?vue&type=template&id=645481eb&scoped=true&"
import script from "./matomo-traefik.vue?vue&type=script&lang=js&"
export * from "./matomo-traefik.vue?vue&type=script&lang=js&"
import style0 from "./matomo-traefik.vue?vue&type=style&index=0&id=645481eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645481eb",
  null
  
)

export default component.exports